module.exports = __webpack_public_path__ + "img/Prestige-Plus-drawing-584x584.4ac20dbe.webp";